import { createFileRoute } from '@tanstack/react-router';
import { NotFoundCard } from '../components/errors/ErrorCard.tsx';

export const Route = createFileRoute('/appointments')({
  component: NotFoundCard,
  staticData: { title: 'Termine' },
});
